import { SelectionListAction, SelectionActionKeys } from './actions';

const initialState = [];

export function selection(state: number[] = initialState, action: SelectionListAction): number[] {
	switch (action.type) {
		case SelectionActionKeys.LOAD_SELECTION:
			return action.selectionIds;
		case SelectionActionKeys.TOGGLE_SELECTION:
			return action.selectionIds;
		case SelectionActionKeys.CLEAR_SELECTION:
			return [];
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Selection/reducer.ts